import type {
  FetchMerchantApprovalsParams,
  MerchantApprovalData,
  MerchantApprovalDetail,
} from "../model/MerchantApprovalModel";
import type { IMerchantApprovalRepository } from "../repository/IMerchantApprovalRepository";
import { merchantApprovalContainer, TYPES } from "../../di/MerchantApprovalModule";

export const FetchMerchantApprovalsUseCase = async (
  params: FetchMerchantApprovalsParams = {},
): Promise<MerchantApprovalData> => {
  const repository = merchantApprovalContainer.get<IMerchantApprovalRepository>(
    TYPES.IMerchantApprovalRepository,
  );

  return repository.fetchApprovals(params);
};

export const FetchMerchantApprovalDetailUseCase = async (
  merchantId: string,
): Promise<MerchantApprovalDetail> => {
  const repository = merchantApprovalContainer.get<IMerchantApprovalRepository>(
    TYPES.IMerchantApprovalRepository,
  );

  return repository.fetchDetail(merchantId);
};

export const ApproveMerchantUseCase = async (
  merchantId: string,
): Promise<void> => {
  const repository = merchantApprovalContainer.get<IMerchantApprovalRepository>(
    TYPES.IMerchantApprovalRepository,
  );

  await repository.approveMerchant(merchantId);
};

export const RejectMerchantUseCase = async (
  merchantId: string,
  reason: string,
): Promise<void> => {
  const repository = merchantApprovalContainer.get<IMerchantApprovalRepository>(
    TYPES.IMerchantApprovalRepository,
  );

  await repository.rejectMerchant(merchantId, { reason });
};
